import { styled } from '@linaria/react';
import Globe from './svg/globe.svg?react';

export const StyledGlobe = styled(Globe)`
  && path {
    stroke: none;
  }
  width: 15px;
`;
